import Dropdown from './Dropdown';
import { connect } from 'react-redux';
import { logOut } from '../../actions/auth';

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(logOut()),
});

export default connect(null, mapDispatchToProps)(Dropdown);
